import { Notifier } from '@airbrake/browser';

const airbrake = process.env.GATSBY_AIRBRAKE_PROJECT_ID && process.env.GATSBY_AIRBRAKE_API_KEY && new Notifier({
  projectId: process.env.GATSBY_AIRBRAKE_PROJECT_ID,
  projectKey: process.env.GATSBY_AIRBRAKE_API_KEY,
  environment: process.env.GATSBY_AIRBRAKE_ENVIRONMENT,
});

if (!airbrake) {
  console.warn(`Airbrake not set up: ${process.env.GATSBY_AIRBRAKE_PROJECT_ID} && ${process.env.GATSBY_AIRBRAKE_API_KEY}`)
}

export default function reportAirbrakeError(e) {
  airbrake && airbrake.notify(e).then(notice => {
    if (notice.id) {
      console.debug('Airbrake notice id: ', notice.id);
    } else {
      console.debug('Airbrake notify failed: ', notice.error);
    }
  });
};